import { formatPrice } from '@/lib/helpers';
import { Text } from '@mantine/core';
import { PiCheck, PiX } from 'react-icons/pi';
import { IPriceCellConfig } from './ServicePriceCellSettings';

export default function ServicePriceDisplay({
  config,
  price,
}: {
  config: IPriceCellConfig;
  price: { amount: number; currency: string };
}) {
  return config.displayIcon ? (
    config.included ? (
      <PiCheck color="green" style={{ display: 'block' }} />
    ) : (
      <PiX color="red" style={{ display: 'block' }} />
    )
  ) : config.included ? (
    <Text size="xs">{formatPrice(price.amount, price.currency)}</Text>
  ) : (
    <Text size="xs">{formatPrice(0, price.currency)}</Text>
  );
}
